"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchModal;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SVBSearchModal(props) {
  const {
    children,
    extraClasses,
    show
  } = props;
  const finalClass = extraClasses ? extraClasses + " modal" : "modal";
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "svb-search-modal",
    className: finalClass,
    tabIndex: "-1",
    role: "dialog",
    "aria-hidden": "true",
    style: {
      display: show ? "block" : "none"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-dialog",
    role: "dialog",
    "data-bs-backdrop": "false"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-content"
  }, children)));
}
SVBSearchModal.propTypes = {
  show: _propTypes.default.bool,
  extraClasses: _propTypes.default.string,
  children: _propTypes.default.node
};